var _path, _path2, _path3, _path4, _g, _path5, _path6, _path7, _g2, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDarkCartIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.25293 7.81299L6.82381 14.603C6.86547 15.1256 7.29244 15.5175 7.81409 15.5175H7.81788H18.1477H18.1496C18.6428 15.5175 19.0641 15.1502 19.1342 14.6626L20.0336 8.45298C20.0544 8.30529 20.0175 8.1576 19.9275 8.03831C19.8385 7.91808 19.7079 7.84044 19.5602 7.81962C19.3623 7.82719 11.1513 7.81583 6.25293 7.81299ZM7.81382 16.9373C6.56697 16.9373 5.51136 15.964 5.41006 14.7191L4.54286 4.40535L3.11613 4.1592C2.72892 4.09103 2.47046 3.72465 2.53673 3.33744C2.60489 2.95022 2.97885 2.69839 3.35755 2.75898L5.32675 3.09981C5.64391 3.15566 5.88532 3.41885 5.91278 3.74074L6.13526 6.39254C19.6508 6.39822 19.6944 6.40485 19.7597 6.41242C20.287 6.48911 20.7509 6.76461 21.0671 7.18874C21.3833 7.61193 21.5159 8.13358 21.4401 8.65618L20.5417 14.8649C20.3722 16.0464 19.346 16.9373 18.1531 16.9373H18.1484H7.82139H7.81382Z",
    fill: "#202020"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6279 11.3122H14.0035C13.6106 11.3122 13.2935 10.9941 13.2935 10.6021C13.2935 10.2102 13.6106 9.89209 14.0035 9.89209H16.6279C17.0198 9.89209 17.3379 10.2102 17.3379 10.6021C17.3379 10.9941 17.0198 11.3122 16.6279 11.3122Z",
    fill: "#202020"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.41099 19.5093C7.69596 19.5093 7.92601 19.7393 7.92601 20.0243C7.92601 20.3093 7.69596 20.5403 7.41099 20.5403C7.12508 20.5403 6.89502 20.3093 6.89502 20.0243C6.89502 19.7393 7.12508 19.5093 7.41099 19.5093Z",
    fill: "#202020"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_411_9505",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 19,
    width: 2,
    height: 2
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.88721 20.0238C6.88721 20.3097 7.11726 20.5407 7.40412 20.5407C7.68909 20.5407 7.91915 20.3097 7.91915 20.0238C7.91915 19.7388 7.68909 19.5088 7.40412 19.5088C7.11726 19.5088 6.88721 19.7388 6.88721 20.0238Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_411_9505)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.15283 25.2732H12.6512V14.7749H2.15283V25.2732Z",
    fill: "#202020"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.40551 19.8294C7.29853 19.8294 7.21143 19.9165 7.21143 20.0235C7.21143 20.2384 7.60054 20.2384 7.60054 20.0235C7.60054 19.9165 7.51249 19.8294 7.40551 19.8294ZM7.39988 21.2494C6.72391 21.2494 6.1748 20.6994 6.1748 20.0234C6.1748 19.3474 6.72391 18.7983 7.39988 18.7983C8.07584 18.7983 8.6259 19.3474 8.6259 20.0234C8.6259 20.6994 8.07584 21.2494 7.39988 21.2494Z",
    fill: "#202020"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0829 19.5083C18.3678 19.5083 18.5988 19.7384 18.5988 20.0233C18.5988 20.3083 18.3678 20.5393 18.0829 20.5393C17.797 20.5393 17.5669 20.3083 17.5669 20.0233C17.5669 19.7384 17.797 19.5083 18.0829 19.5083Z",
    fill: "#202020"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_411_9505",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 19,
    width: 2,
    height: 2
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5669 20.0238C17.5669 20.3097 17.797 20.5407 18.0829 20.5407C18.3669 20.5407 18.5988 20.3097 18.5988 20.0238C18.5988 19.7388 18.3669 19.5088 18.0829 19.5088C17.797 19.5088 17.5669 19.7388 17.5669 20.0238Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_411_9505)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8325 25.2732H23.3318V14.7749H12.8325V25.2732Z",
    fill: "#202020"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.094 19.8291C17.988 19.8291 17.9009 19.9162 17.9009 20.0232C17.9018 20.24 18.29 20.2381 18.289 20.0232C18.289 19.9162 18.201 19.8291 18.094 19.8291ZM18.0888 21.2494C17.4129 21.2494 16.8638 20.6994 16.8638 20.0234C16.8638 19.3474 17.4129 18.7983 18.0888 18.7983C18.7658 18.7983 19.3158 19.3474 19.3158 20.0234C19.3158 20.6994 18.7658 21.2494 18.0888 21.2494Z",
    fill: "#202020"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkCartIcon);
export default __webpack_public_path__ + "static/media/darkCartIcon.cccaa55666c1e3be965641114f3d4376.svg";
export { ForwardRef as ReactComponent };